const _poppins = ["Poppins","Poppins","Poppins","Poppins"]
const config = { "poppins": _poppins, "hanken_grotesk": ["Hanken Grotesk","Hanken Grotesk","Hanken Grotesk","Hanken Grotesk"], "space_grotesk": ["Space Grotesk","Space Grotesk","Space Grotesk","Space Grotesk"],  }
export { config as default, _poppins }